import React, { useMemo } from 'react';
import './Header.scss';
import '../Desktop/DesktopHeader/DesktopHeader.scss';
import { Creator } from '../../../../Models/Creator';
import SeriesPoster from '../../../InkyPenUIKit/SeriesPoster/SeriesPoster';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { useAtomValue } from 'jotai';
import { AccountInfoAtom } from '../../../../store/AccountStore';
import { SingleSeriesAtom } from '../../../../store/SeriesStore';


// interface HeaderProps {
//     title: string;
//     authors?: Creator[];
//     cover?: string;
//     color?: string;
//     description?: string;
//     firstProductID?: number;
//     id?: number;
//     onlyBooks: boolean;
//     renderReadChapters: () => JSX.Element;
//     chapterToRead?: { type: 'Volume' | 'Chapter' | null; data: Product | Comic };
// }


export function SeriesPictureAndBreadCrumb() {
    const series = useAtomValue(SingleSeriesAtom);

    const cover = series?.thumbnails[0]?.url;
    const color = series?.thumbnails[0]?.color;

    console.log('cover', cover, series);

    const ratio = useMemo(() => {
        if (series.thumbnails?.[0]) {
            return (series.thumbnails[0].height / series.thumbnails[0].width) * 100;
        }
        return 150;
    }, [series.thumbnails]);

    return (
        <div className='series-breadcrumb-poster-wrapper'>
            <div className='series-poster-wrapper'>
                <div className={'hide-breadcrumb-on-desktop'}>
                    <SeriesPoster preloadImage={true} hover={false} src={cover} ratio={ratio}
                                  color={color}
                                  alt={'cover for ' + series?.title} />
                </div>

                <div className={'hide-on-mobile-series'}>
                    <SeriesPoster preloadImage={true} hover={false} src={cover} ratio={ratio}
                                  color={color}
                                  alt={'cover for ' + series?.title} />
                </div>
            </div>
        </div>
    );
}

const mapCreators = (creators: Creator[]): string[] => {

    // const leadAuthors = creators.filter(value => value.title === "Lead Author");
    const leadAuthors = creators;

    return leadAuthors?.map((creator, index) => {
        if (leadAuthors.length === 1) {
            return creator.name;
        } else if ((leadAuthors.length === 2 && index === 0) || (leadAuthors.length === index + 2)) {
            return creator.name + ' and ';
        }
        if (leadAuthors.length === index + 1) {
            return creator.name;
        } else {
            return creator.name + ', ';
        }
    });
};

export function SeriesTitleAndDescription() {
    const accountInfo = useAtomValue(AccountInfoAtom);
    const series = useAtomValue(SingleSeriesAtom);
    return (
        <>
            <h1 className='series-desktop-header-info-title'>
                {series?.title}
            </h1>

            {/* TODO: Post Beta Feature */}
            {series?.creators && <span className='series-desktop-header-info-author-series'>
                                 By {(series.creators && mapCreators(series.creators)) ?? ''}
                            </span>}

            {series && accountInfo.roles?.find(x => x.toLowerCase() == 'admin') ?
                <Link to={'/dashboard/series/' + series.id} className='edit-product-for-admin'>
                    <FontAwesomeIcon icon={faEdit} size='2x' />
                    <span>
                                        Edit Series
                                    </span>
                </Link>
                : null}

            {/* this is not recommended way for rendering html tags from the server */}
            <div className='hide-on-mobile-series'>
                <p className='series-desktop-header-info-description'
                   dangerouslySetInnerHTML={{ __html: series?.description }} />
            </div>

            {/*<Free link={'product/' + props?.firstProductID?.toString()} />*/}
        </>
    );
}

// const Header = (props: HeaderProps): JSX.Element => {
//
//     Log.info("Render Series Header...");
//
//     return (
//         <>
//             <div className='header-on-mobile'>
//                 <div className='series-grid-header'>
//                     <SeriesPictureAndBreadCrumb cover={props.cover}
//                                                 color={props.color}
//                                                 title={props.title}
//                                                 onlyBooks={props.onlyBooks}
//                     />
//                     <div className='series-desktop-header-info-wrapper-series'>
//                         <SeriesTitleAndDescription title={props.title}
//                                                    description={props.description}
//                                                    authors={props.authors}
//                                                    id={props.id}
//                                                    />
//
//
//                         <div className='series-desktop-reader-chapter'>
//                             {props.renderReadChapters()}
//                         </div>
//                     </div>
//
//                 </div>
//
//             </div>
//         </>
//
//     );
// };

// export default React.memo(Header);
